import { useMutation, useQueryClient } from 'react-query'
import { coreAPI } from '../coreApi'
import useUserId from './useUserId'
import { TProgramAcceptancePayload } from '../types/feed'
const useSubmitApproval = () => {
  const userId = useUserId()
  const queryClient = useQueryClient()
  const approve = useMutation(
    (mutationPayload: TProgramAcceptancePayload) =>
      coreAPI.post(`/v1/management/users/${userId}/approvals`, mutationPayload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('userRecords')
        queryClient.invalidateQueries('userDetail')
      },
    },
  )

  return approve
}

export default useSubmitApproval
